import React, { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Payment from './Payment';
import EveryPayPayment from './EveryPayPayment';
import { isEveryPayLink } from './paymentLinkSwitch';

// /external/payment/:lang/:orderId: every link the payment parser understands goes
// to EveryPay (ws5 pay/*); see paymentLinkSwitch.js. When ws5 answers not_available
// for an order, completed order or tip (web rail switched off, or a useTmpPrice
// order), EveryPayPayment hands back the legacy-form id (<recid>, <recid>completed
// or <recid>tips) and the legacy Montonio page (Payment.jsx) takes the link with
// that id. The fallback is keyed to the link, so a new link in the same tab starts
// on EveryPay again. EveryPayPayment is keyed to the link too: a new link mounts a
// fresh page, so no notice, refusal, pending pay/start or fallback callback from
// the previous link can reach it.
function PaymentRoute() {
    const { orderId } = useParams();
    const [searchParams] = useSearchParams();
    const linkKey = `${orderId || ''}?${searchParams.toString()}`;
    const [legacy, setLegacy] = useState(null); // { key, id } once EveryPay handed the link back

    if (legacy && legacy.key === linkKey && legacy.id) {
        return <Payment orderIdOverride={legacy.id} />;
    }
    if (!isEveryPayLink(orderId, searchParams)) {
        return <Payment />;
    }
    return <EveryPayPayment key={linkKey} onNotAvailable={(id) => setLegacy({ key: linkKey, id })} />;
}

export default PaymentRoute;
